export { calcRoot, reduceNum } from './data';

export function calcPersonalYear(day, month, year = new Date().getFullYear()) {
  const digits = String(day) + String(month) + String(year);
  let s = digits.split('').reduce((a,b) => a + parseInt(b), 0);
  while (s > 9) s = String(s).split('').reduce((a,b) => a + parseInt(b), 0);
  return s;
}

export const NUMBERS = [
  { num: '1:11 / 11:11', meaning: 'نداء ذاتي للانفصال عن القديم' },
  { num: '2:22', meaning: 'اختبار عاطفي أو قرار معلق' },
  { num: '3:33', meaning: 'دعوة للتعبير أو التحرك' },
  { num: '4:44', meaning: 'تحذير من التعلق أو الركود' },
  { num: '5:55', meaning: 'تغيّر مفاجئ — الباب سيُفتح أو يُغلق' },
  { num: '6:06 / 66', meaning: 'توتر داخلي عاطفي' },
  { num: '7:07 / 77', meaning: 'حضور روحي — رسالة من اللامرئي' },
  { num: '8:08 / 888', meaning: 'دورة مالية أو قدرية جديدة' },
  { num: '9:09 / 999', meaning: 'نهاية مرحلة — اكتمال تعلم قديم' },
];
